import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

export default function CategoryFilter({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <div className="bg-card rounded-lg shadow-organic-sm p-6 border border-border">
      <h3 className="text-lg font-headline font-bold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="FunnelIcon" size={20} variant="outline" />
        <span>Filter by Category</span>
      </h3>
      
      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full flex items-center justify-between px-4 py-3 rounded-md transition-organic duration-300 ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-organic-sm'
                : 'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            <div className="flex items-center space-x-3">
              <Icon 
                name={category.icon as any} 
                size={20} 
                variant={activeCategory === category.id ? 'solid' : 'outline'} 
              />
              <span className="font-body font-medium">{category.name}</span>
            </div>
            <span className={`text-sm font-body ${
              activeCategory === category.id ? 'text-primary-foreground/80' : 'text-muted-foreground'
            }`}>
              {category.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}